<template>
  <q-scroll-area style="height: calc(100vh - 420px) !important">
    <div v-if="gridData.length > 0" class="q-px-md">
      <q-card bordered flat class="q-pa-md q-my-md">
        <div v-for="(races, index) in gridData" :key="`event_${index}`">
          <span
            v-if="
              races[0].distance_m && competition.competition_type != 'BEACH'
            "
            >{{ races[0].distance_m }}m</span
          >
          {{ races[0].discipline_name }}
          <br />
          <div
            v-for="(race, rIndex) in sortedRaces(races)"
            :key="`race_${rIndex}`"
            v-if="race.lanes.length > 0"
          >
            {{ race.division_name }}.
            <span v-for="(lane, lIndex) in race.lanes" :key="`lane_${lIndex}`">
              {{ lane.team_name
              }}<span v-if="!lane.team_id">, {{ lane.association_abbr }}</span>
              <span
                v-if="lane.team_id"
                v-for="(member, mIndex) in lane.teamMembers"
                :key="`member_${mIndex}`"
              >
                {{ mIndex == 0 ? "(" : "" }}{{ member.firstName }}
                {{ member.lastName
                }}{{ mIndex < lane.teamMembers.length - 1 ? "/" : ")" }}
              </span>

              {{ lane.placing
              }}{{ lIndex < race.lanes.length - 1 ? ", " : "." }}
            </span>
          </div>
          <br />
        </div>
      </q-card>
    </div>
  </q-scroll-area>
</template>

<script>
import datatable from "@/components/datatable/datatable.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    gridData: [],
    search: {
      default: "",
      type: String
    }
  },
  computed: {
    sortedData() {
      return this.gridData;
    },
    ...mapGetters({
      competition: "competitions/current"
    })
  },
  components: {
    datatable
  },
  data() {
    return {};
  },
  methods: {
    handleDoubleClick(row) {
      console.log(row);
    },

    sortedRaces(races) {
      let data = JSON.parse(JSON.stringify(races));
      return data.sort((a, b) => {
        const aNum = parseInt(a.division_name);
        const bNum = parseInt(b.division_name);
        const aType = a.division_name.split(" ")[0];
        const bType = b.division_name.split(" ")[0];

        if (aNum && bNum) {
          // Compare the division numbers
          if (aNum !== bNum) {
            return aNum - bNum;
          }

          // If the division numbers are the same, compare the division types
        } else {
          if (aType !== bType) {
            if (aType === "Open") return 1;
            if (bType === "Open") return -1;
            return aType.localeCompare(bType);
          }
          // If the division numbers are not present in the division names, use the existing comparison
          return a.division_name.localeCompare(b.division_name);
        }

        // If none of the conditions above are met, the elements are considered equal
        return 0;
      });
    }
  }
};
</script>

<style></style>template
